const docControl = {
  overview: "Overview",
  viewHistory: "View History",
  fieldLocks: "Field Locks",
  messages: "Messages",
  auditLog: "Audit Log",
  notFound: "Document not found",
  backToList: "Back to list",
  liveViewing: "Currently viewing",
  submitters: "Submitters",
  totalViews: "Views",
  lockedFields: "Locked Fields",
  unreadMessages: "Unread Messages",
  documentInfo: "Document Info",
  created: "Created",
  sentAt: "Sent",
  signedAt: "Signed",
  expiresAt: "Expires",
  cancelledAt: "Cancelled",
  pdfHash: "PDF Hash",
  unnamed: "Unnamed",
  role_signer: "Signer",
  role_witness: "Witness",
  role_approver: "Approver",
  actions: "Actions",
  markSent: "Mark as Sent",
  cancel: "Cancel Document",
  archive: "Archive",
  statusDraft: "Draft",
  statusSent: "Sent",
  statusViewed: "Viewed",
  statusPartial: "Partial",
  statusSigned: "Signed",
  statusExpired: "Expired",
  statusCancelled: "Cancelled",
  statusArchived: "Archived",
  noViews: "No views yet",
  duration: "Duration",
  noLocks: "No locked fields",
  lockedBy: "Locked by",
  unlock: "Unlock",
  noMessages: "No messages",
  internal: "Internal",
  submitterMsg: "Submitter",
  typeMessage: "Type a message...",
  noAudit: "No audit entries",
  checklist: "Checklist",
  noChecklist: "No checklist items",
  required: "Required",
  acceptedTypes: "Accepted types",
  maxSize: "Max size",
  uploadFile: "Upload file",
  uploadAnother: "Upload another",
  approve: "Approve",
  reject: "Reject",
  rejectReason: "Rejection reason...",
  cancelAction: "Cancel",
  review_pending: "Pending",
  review_approved: "Approved",
  review_rejected: "Rejected",
  downloadPdf: "Download PDF",
  generateAndStore: "Generate & Store PDF",
  signers: "Signers",
  addSigner: "Add Signer",
  noSigners: "No signers added yet",
  sendForSigning: "Send for Signing",
  sendForSigningDesc: "Generate a signing link and send the document",
  sendNow: "Send Now",
  signingLink: "Signing Link",
  copyLink: "Copy",
  copied: "Copied!",
  documentSentInfo: "Document has been sent for signing",
  fullName: "Full Name",
  emailAddress: "Email",
  phoneNumber: "Phone",
  edit: "Edit",
  delete: "Delete",
  save: "Save",
  declined: "Declined",
  fieldValues: "Field Values",
  contentPreview: "Content Preview",
  showLess: "Show less",
  showMore: "Show more",
  moreLines: "more lines",
  resendLink: "Resend Link",
  sendReminder: "Reminder",
  revokeDocument: "Revoke",
  editContent: "Edit Content",
  editWarning: "Document has been sent — editing is only available for drafts",
  noFieldValues: "No field values",
  fieldsReadOnly: "Fields are read-only — editing is only available for drafts",
} as const;
export default docControl;
